import React, { useEffect, useState } from 'react';
import { api, HttpErrorResponseModel } from 'react-structure-admin';
import moment from 'moment';

const InboundInvoiceSyncStatus = ({
  refreshKey,
  detailed,
  resource = 'inbound-product-invoices'
}) => {
  const [status, setStatus] = useState(null);

  useEffect(() => {
    let active = true;

    api.get(resource, 'sync-status').then((response) => {
      if (!active || response instanceof HttpErrorResponseModel) {
        return;
      }

      setStatus(response?.result ?? response?.data?.result ?? response);
    });

    return () => {
      active = false;
    };
  }, [refreshKey, resource]);

  if (!status || !status.lastSyncAt) {
    return null;
  }

  const lastSync = moment(status.lastSyncAt).format('DD/MM/YYYY HH:mm');
  const blockedUntil =
    status.nextAllowedSyncAt && moment(status.nextAllowedSyncAt).isAfter(moment())
      ? moment(status.nextAllowedSyncAt)
      : null;

  if (detailed) {
    return (
      <div className="gx-text-grey gx-fs-sm">
        <div>Última sincronização: {lastSync}</div>
        {blockedUntil ? (
          <div>
            Próxima disponível a partir de:{' '}
            {blockedUntil.format('DD/MM/YYYY HH:mm')}
          </div>
        ) : null}
        <div>Último NSU: {status.lastNsu ?? 0}</div>
      </div>
    );
  }

  const last = lastSync
    ? `Última sincronização: ${lastSync}`
    : 'Ainda não sincronizado';
  const next = blockedUntil
    ? ` · Próxima disponível a partir de ${blockedUntil.format('HH:mm')}`
    : '';

  return (
    <span className="gx-text-grey gx-fs-sm">
      {last}
      {next}
    </span>
  );
};

export default InboundInvoiceSyncStatus;
